(function() {
  function styleArrow(arrow) {
    arrow.style.setProperty("opacity", "0", "important");
    arrow.style.setProperty("transition", "opacity .2s ease", "important");
    arrow.style.setProperty("width", "36px", "important");
    arrow.style.setProperty("height", "36px", "important");
    arrow.style.setProperty("background-color", "rgba(0,0,0,.2)", "important");
    arrow.style.setProperty("fill", "rgb(255,255,255)", "important");
    arrow.style.setProperty("box-shadow", "0 1px 4px rgba(0,0,0,.12)", "important");
    var svg = arrow.querySelector("svg");
    if (svg) { svg.setAttribute("width", "14"); svg.setAttribute("height", "14"); }
    if (arrow.classList.contains("pwzrswiper-btn-next")) {
      arrow.style.setProperty("right", "12px", "important");
    } else {
      arrow.style.setProperty("left", "12px", "important");
    }
    arrow.dataset.styled = "1";
  }

  function styleSlides() {
    var wrapper = document.getElementById("pwzrswiper-container-wrapper");
    if (!wrapper) return;
    wrapper.querySelectorAll(".pwzrswiper-slide").forEach(function(slide) {
      if (slide.dataset.ratio) return;
      slide.style.setProperty("padding-bottom", "125%", "important");
      slide.dataset.ratio = "1";
    });
    wrapper.querySelectorAll(".pwzrswiper-slide img").forEach(function(img) {
      if (img.dataset.cover) return;
      img.style.setProperty("position", "absolute", "important");
      img.style.setProperty("top", "0", "important");
      img.style.setProperty("left", "0", "important");
      img.style.setProperty("width", "100%", "important");
      img.style.setProperty("height", "100%", "important");
      img.style.setProperty("object-fit", "cover", "important");
      img.dataset.cover = "1";
      var src = img.getAttribute("src") || img.getAttribute("data-src");
      if (src && !img.getAttribute("srcset")) {
        var base = src.replace(/[?&]width=\d+/, "");
        var sep = base.indexOf("?") > -1 ? "&" : "?";
        img.setAttribute("srcset",
          base + sep + "width=1200 600w, " +
          base + sep + "width=1600 800w, " +
          base + sep + "width=1980 990w"
        );
        img.setAttribute("sizes", "(max-width: 767px) 100vw, 50vw");
      }
    });
    var swiperWrapper = document.getElementById("pwzrswiper-wrapper");
    if (swiperWrapper) { swiperWrapper.style.setProperty("height", "auto", "important"); }
  }

  function styleAll() {
    var wrapper = document.getElementById("pwzrswiper-container-wrapper");
    if (wrapper) {
      wrapper.querySelectorAll(".pwzrswiper-btn-prev, .pwzrswiper-btn-next").forEach(function(a) {
        if (a.dataset.styled !== "1") styleArrow(a);
      });
      styleSlides();
    }
  }

  new MutationObserver(styleAll).observe(document.body, { childList: true, subtree: true });

  document.addEventListener("mousemove", function(e) {
    var wrapper = document.getElementById("pwzrswiper-container-wrapper");
    if (!wrapper || !wrapper.contains(e.target)) return;
    var prev = wrapper.querySelector(".pwzrswiper-btn-prev");
    var next = wrapper.querySelector(".pwzrswiper-btn-next");
    if (!prev || !next) return;
    var mid = wrapper.getBoundingClientRect().left + wrapper.getBoundingClientRect().width / 2;
    if (e.clientX < mid) {
      prev.style.setProperty("opacity", "1", "important");
      next.style.setProperty("opacity", "0", "important");
    } else {
      next.style.setProperty("opacity", "1", "important");
      prev.style.setProperty("opacity", "0", "important");
    }
  });

  document.addEventListener("mouseout", function(e) {
    var wrapper = document.getElementById("pwzrswiper-container-wrapper");
    if (!wrapper || !wrapper.contains(e.target)) return;
    if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
    wrapper.querySelectorAll(".pwzrswiper-btn-prev, .pwzrswiper-btn-next").forEach(function(a) {
      a.style.setProperty("opacity", "0", "important");
    });
  });
})();

;(function () {
  'use strict';

  var GALLERY_SEL = '[data-product-single-media-group]';
  var SLIDER_SEL  = '[data-product-single-media-slider]';
  var HOST_SEL    = '[data-section-type="product-template"]';

  var FLICKITY_JS  = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
  var FLICKITY_CSS = 'https://unpkg.com/flickity@2/dist/flickity.min.css';
  var _flickityPromise = null;

  var FLICKITY_OPTS = {
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    adaptiveHeight: true,
    wrapAround: true,
    dragThreshold: 3,
    percentPosition: true,
    cellSelector: '.product-gallery__media-slide'
  };

  var _ourFlickity = null;

  function ensureFlickity() {
    if (window.Flickity) return Promise.resolve(window.Flickity);
    if (_flickityPromise) return _flickityPromise;

    _flickityPromise = new Promise(function (resolve, reject) {
      if (!document.getElementById('vk-flickity-css')) {
        var link = document.createElement('link');
        link.id = 'vk-flickity-css';
        link.rel = 'stylesheet';
        link.href = FLICKITY_CSS;
        document.head.appendChild(link);
      }
      var script = document.createElement('script');
      script.src = FLICKITY_JS;
      script.onload = function () { resolve(window.Flickity); };
      script.onerror = function () { reject(new Error('flickity load failed')); };
      document.head.appendChild(script);
    });

    return _flickityPromise;
  }

  function init() {
    if (document.documentElement.dataset.vkGallerySwap) return;
    document.documentElement.dataset.vkGallerySwap = '1';

    var cache = {};
    var lastVariantId = null;
    var timer = null;
    var inFlight = false;

    function host() { return document.querySelector(HOST_SEL); }

    function currentVariantId() {
      var h = host();
      if (!h) return null;
      var input = h.querySelector('[data-product-select]') || h.querySelector('input[name="id"]');
      return input && input.value ? input.value : null;
    }

    lastVariantId = currentVariantId();

    function requestSwap() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(swap, 120);
    }

    function applyGallery(current, next, needsCarousel) {
      if (_ourFlickity) {
        try { _ourFlickity.destroy(); } catch (e) {}
        _ourFlickity = null;
      }

      current.replaceWith(next);

      if (!needsCarousel) {
        document.dispatchEvent(new CustomEvent('theme:variant:change'));
        return;
      }

      ensureFlickity().then(function (Flickity) {
        var slider = next.querySelector(SLIDER_SEL);
        if (!slider) return;
        try {
          _ourFlickity = new Flickity(slider, FLICKITY_OPTS);
        } catch (e) {
          console.warn('[vk:gallery] flickity init failed', e);
        }
        document.dispatchEvent(new CustomEvent('theme:variant:change'));
      }).catch(function (err) {
        console.warn('[vk:gallery]', err);
        document.dispatchEvent(new CustomEvent('theme:variant:change'));
      });
    }

    function swap() {
      if (inFlight) return;

      var h = host();
      if (!h) return;

      var sectionId = h.dataset.sectionId;
      if (!sectionId) return;

      var variantId = currentVariantId();
      if (!variantId || variantId === lastVariantId) return;

      var live = document.querySelector(GALLERY_SEL);
      if (!live) return;

      var liveSlider = live.querySelector(SLIDER_SEL);
      var needsCarousel = !!(liveSlider && liveSlider.classList.contains('flickity-enabled'));

      lastVariantId = variantId;
      inFlight = true;

      var url = location.pathname + '?variant=' + encodeURIComponent(variantId) +
                '&section_id=' + encodeURIComponent(sectionId);

      var done = function (html) {
        inFlight = false;
        if (!html) return;

        var doc;
        try { doc = new DOMParser().parseFromString(html, 'text/html'); }
        catch (e) { return; }

        var next = doc.querySelector(GALLERY_SEL);
        var current = document.querySelector(GALLERY_SEL);
        if (!next || !current) return;

        applyGallery(current, next, needsCarousel);
      };

      if (cache[url]) { done(cache[url]); return; }

      fetch(url)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html) cache[url] = html;
          done(html);
        })
        .catch(function (err) {
          inFlight = false;
          console.warn('[vk:gallery] swap failed', err);
        });
    }

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(HOST_SEL)) return;
      if (e.target.matches('[data-single-option-selector]') || e.target.name === 'id') {
        requestSwap();
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest(HOST_SEL)) return;
      if (e.target.closest('[data-popout-option]')) requestSwap();
    });

    window.addEventListener('popstate', function () {
      lastVariantId = null;
      requestSwap();
    });

    if (document.querySelector('[data-product]')) {
      if (window.requestIdleCallback) {
        requestIdleCallback(function () { ensureFlickity(); }, { timeout: 3000 });
      } else {
        setTimeout(function () { ensureFlickity(); }, 2000);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();